import { render, staticRenderFns } from "./IdeaSpaceDeleteDialog.vue?vue&type=template&id=8e7d994c&scoped=true"
import script from "./IdeaSpaceDeleteDialog.vue?vue&type=script&lang=js"
export * from "./IdeaSpaceDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./IdeaSpaceDeleteDialog.vue?vue&type=style&index=0&id=8e7d994c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7d994c",
  null
  
)

export default component.exports